import {
  CONFIG_SERVICE_KEYS,
  FEATURE_DECISION_KEYS,
} from '@web-platform/shared-universal-constants-config';
import {
  getConfigServiceValue,
  getFeatureDecision,
} from '@web-platform/shared-universal-utils-frontend/src/config';
import { importRetryWrapper } from '@web-platform/shared-universal-utils-frontend/src/helpers/lazyLoading';
import { logWarn } from 'saddlebag-logger';

let hasBeenCalled = false;

export const resetEnableWebToApp = () => {
  hasBeenCalled = false;
};

export const enableWebToApp = ({
  destinationName,
  isPaidAdDisplayed,
  originName,
}: {
  destinationName: string;
  isPaidAdDisplayed: boolean;
  originName: string;
}) => {
  if (hasBeenCalled) return;
  hasBeenCalled = true;

  const shouldEnableWebToApp =
    getFeatureDecision(FEATURE_DECISION_KEYS.ENABLE_WEB_TO_APP_BANNERS) &&
    getFeatureDecision(FEATURE_DECISION_KEYS.ENABLE_WEB_TO_APP_BANNERS_BANANA);
  if (shouldEnableWebToApp) {
    importRetryWrapper(
      () =>
        import(
          /* webpackChunkName: "saddlebag-web-to-app" */
          '@skyscanner-internal/saddlebag-web-to-app'
        ),
    )
      .then(({ default: initialiseWebToApp }) => {
        const bannerID = getConfigServiceValue(CONFIG_SERVICE_KEYS.EXPERIMENT.WEB_TO_APP_BANNER_ID);

        const initialisationKey = getConfigServiceValue(
          process.env.NODE_ENV === 'production'
            ? CONFIG_SERVICE_KEYS.EXPERIMENT.WEB_TO_APP_INITIALISATION_KEY_PROD
            : CONFIG_SERVICE_KEYS.EXPERIMENT.WEB_TO_APP_INITIALISATION_KEY_TEST,
        );
        initialiseWebToApp({
          bannerID,
          initialisationKey,
          isPaidAdDisplayed,
          originName,
          destinationName,
        });
      })
      .catch((err) => {
        logWarn({
          component: 'enableWebToApp',
          message: 'Failed to import saddlebag-web-to-app',
          error: err,
        });
      });
  }
};
